module.exports = __webpack_public_path__ + "static/media/verified_under_1m.2686f292.avif";